import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "RechargeModal",
  tabindex: "-1",
  ref: "rechargeModalRef",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content p-15 p-md-40" }
const _hoisted_4 = { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25 border-0" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "text-muted mb-0"
}
const _hoisted_7 = {
  key: 1,
  class: "text-info small mb-0"
}
const _hoisted_8 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = {
  class: "btn-group mb-3 w-100",
  role: "group"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "col-md-12" }
const _hoisted_21 = { class: "d-flex gap-2" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-close position-absolute top-0 end-0 mt-3 me-3",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args))),
            disabled: _ctx.processing
          }, null, 8, _hoisted_5),
          _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title fw-bold text-black" }, "Recharger le compte prépayé", -1)),
          (_ctx.account)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Compte: " + _toDisplayString(_ctx.account.accountNumber) + " | Solde actuel: " + _toDisplayString(_ctx.formatAmount(_ctx.account.balance)) + " " + _toDisplayString(_ctx.account.currencyCode), 1))
            : _createCommentVNode("", true),
          (_ctx.account?.creditLimit)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Limite de crédit autorisée: " + _toDisplayString(_ctx.formatAmount(_ctx.account.creditLimit)) + " " + _toDisplayString(_ctx.account.currencyCode), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Form, {
            ref: "rechargeForm",
            onSubmit: _ctx.processRecharge,
            "validation-schema": _ctx.rechargeSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Montant à recharger "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestedAmounts, (amount) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: amount,
                          type: "button",
                          class: "btn btn-outline-primary",
                          onClick: ($event: any) => (_ctx.setAmount(amount))
                        }, _toDisplayString(_ctx.formatAmount(amount)), 9, _hoisted_13))
                      }), 128))
                    ]),
                    _createVNode(_component_Field, { name: "amount" }, {
                      default: _withCtx(({ field, value }) => [
                        _createElementVNode("input", _mergeProps(field, {
                          value: value,
                          type: "number",
                          step: "0.01",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Ou entrer un montant personnalisé"
                        }), null, 16, _hoisted_14)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "amount",
                      class: "text-danger"
                    }),
                    (_ctx.estimatedBalance !== null)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_15, " Solde estimé après rechargement: " + _toDisplayString(_ctx.formatAmount(_ctx.estimatedBalance)) + " " + _toDisplayString(_ctx.account?.currencyCode), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Méthode de paiement "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "paymentMethod" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, {
                          options: _ctx.paymentMethods,
                          searchable: false,
                          "track-by": "value",
                          label: "label",
                          "model-value": field.value,
                          "onUpdate:modelValue": _ctx.handlePaymentMethodChange,
                          placeholder: "Sélectionner une méthode"
                        }, null, 8, ["options", "model-value", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "paymentMethod",
                      class: "text-danger"
                    })
                  ])
                ]),
                (_ctx.selectedPaymentMethod)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['alert', _ctx.getAlertClass(), 'mb-15', 'mb-sm-20', 'mb-md-25'])
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.getPaymentMethodTitle()), 1),
                        _createElementVNode("div", {
                          class: "mt-2",
                          innerHTML: _ctx.getPaymentMethodInfo()
                        }, null, 8, _hoisted_19)
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", {
                      class: "btn btn-success flex-fill",
                      type: "submit",
                      disabled: _ctx.processing || !_ctx.isFormValid
                    }, [
                      (!_ctx.processing)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.getSubmitButtonText()), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_24, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }, null, -1),
                            _createTextVNode(" Traitement en cours... ", -1)
                          ]))]))
                    ], 8, _hoisted_22),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger",
                      "data-bs-dismiss": "modal",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args))),
                      disabled: _ctx.processing
                    }, " Annuler ", 8, _hoisted_25)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ], 512))
}